export const ProjectsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g clipPath="url(#clip0_1925_12636)">
        <path d="M10.0013 1.66406L18.3346 7.08073V12.9141L10.0013 18.3307L1.66797 12.9141V7.08073L10.0013 1.66406Z" />
        <path d="M10 18.3346V12.918" />
        <path d="M18.3346 7.08594L10.0013 12.9193L1.66797 7.08594" />
        <path d="M1.66797 12.9193L10.0013 7.08594L18.3346 12.9193" />
        <path d="M10 1.66797V7.08463" />
      </g>
      <defs>
        <clipPath id="clip0_1925_12636">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
